export var getRootPopup = function getRootPopup() {
  var tooltipRoot = document.getElementById('tooltip-root');
  if (tooltipRoot) return tooltipRoot;
  var newTooltipRoot = document.createElement('div');
  newTooltipRoot.setAttribute('id', 'tooltip-root');
  document.body.appendChild(newTooltipRoot);
  return newTooltipRoot;
};
//# sourceMappingURL=utils.js.map